import { ExitChatModalTranslation } from './types';

export const deTranslations: ExitChatModalTranslation = {
  placeholderOne: 'Auswählen...',  // "Best Guess First"
  placeholderTwo: 'Zweite Differentialdiagnose (optional)',  // "Best Guess Two"
  placeholderThree: 'Dritte Differentialdiagnose (optional)',  // "Best Guess Three"
  modalTitle: 'Bitte wählen Sie nach dieser Anamnese bis zu 3 Differentialdiagnosen aus:',  // "Best Guess Diagnosis"
  saveButton: 'Speichern',  // "Save",
  noteText: "Nach der Anamnese werden folgende Differentialdiagnosen in Betracht gezogen:",
    selectPlaceholder: 'Auswählen...'  // "Auswählen..."
};
